// Scroll Animation Observer
// Triggers animations when elements come into view

document.addEventListener('DOMContentLoaded', function () {
    // Intersection Observer for scroll animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-on-scroll');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe sections and cards
    const animatedElements = document.querySelectorAll(
        '.product-carousel, .featured-grid, .product-card-hallmark, .hallmark-product-grid'
    );

    animatedElements.forEach(el => {
        observer.observe(el);
    });

    // Add stagger animation to product grids
    const productGrids = document.querySelectorAll('.hallmark-product-grid__grid');
    productGrids.forEach(grid => {
        grid.classList.add('stagger-animation');
    });

    // Add stagger animation to carousel tracks
    const carouselTracks = document.querySelectorAll('.product-carousel__track');
    carouselTracks.forEach(track => {
        track.classList.add('stagger-animation');
    });

    // Smooth scroll handled by CSS scroll-behavior property

    // Add ripple effect to buttons
    const buttons = document.querySelectorAll('.btn');
    buttons.forEach(button => {
        button.addEventListener('click', function (e) {
            const ripple = document.createElement('span');
            const rect = this.getBoundingClientRect();
            const size = Math.max(rect.width, rect.height);
            const x = e.clientX - rect.left - size / 2;
            const y = e.clientY - rect.top - size / 2;

            ripple.style.width = ripple.style.height = size + 'px';
            ripple.style.left = x + 'px';
            ripple.style.top = y + 'px';
            ripple.classList.add('ripple');

            this.appendChild(ripple);

            setTimeout(() => ripple.remove(), 600);
        });
    });

    // Parallax effect removed - was causing janky scrolling behavior

    // Card hover sound effect (optional - can be enabled)
    const cards = document.querySelectorAll('.product-card-hallmark');
    cards.forEach(card => {
        card.addEventListener('mouseenter', function () {
            this.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        });
    });

    // Lazy load images with fade-in
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
        img.addEventListener('load', function () {
            this.style.animation = 'fadeIn 0.5s ease-in';
        });
    });

    // Add pulse animation to primary CTAs
    const primaryButtons = document.querySelectorAll('.btn-primary');
    primaryButtons.forEach(btn => {
        setInterval(() => {
            btn.style.animation = 'pulse 2s ease-in-out';
            setTimeout(() => {
                btn.style.animation = '';
            }, 2000);
        }, 10000); // Pulse every 10 seconds
    });
});

// Add CSS for ripple effect
const style = document.createElement('style');
style.textContent = `
  .ripple {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
    transform: scale(0);
    animation: ripple-animation 0.6s ease-out;
    pointer-events: none;
  }
  
  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
document.head.appendChild(style);
